import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/analytics/findings");

export const Route = createFileRoute("/analytics/findings")({
  head: () => ({
    meta: [
      { title: "Plan health — LevelLoad" },
      { name: "description", content: "Plan health — LevelLoad transport planning." },
      { property: "og:title", content: "Plan health — LevelLoad" },
      { property: "og:description", content: "Plan health — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
